import { FunctionComponent, ReactNode } from 'react'

const CheckRow: FunctionComponent<{
  id: string
  checked: boolean
  onChange: (checked: boolean) => void
  title: ReactNode
  description?: ReactNode
  disabled?: boolean
}> = ({ id, checked, onChange, title, description, disabled }) => (
  <label className="check-row" htmlFor={id}>
    <input
      id={id}
      type="checkbox"
      className="form-check-input"
      checked={checked}
      disabled={disabled}
      onChange={(event) => onChange(event.currentTarget.checked)}
    />
    <span>
      <span className="check-title">{title}</span>
      {description && <span className="check-desc">{description}</span>}
    </span>
  </label>
)

export default CheckRow
